import cupOption1 from "/public/Images/cupOption1.gif";
import cupOption2 from "/public/Images/cupOption2.gif";
import cupOption3 from "/public/Images/cupOption3.gif";
import cupOption4 from "/public/Images/cupOption4.gif";
import mouldedBra from "/public/Images/mouldedBra.jpg";
import fabricBra from "/public/Images/fabricBra.jpg";

// bf2
export const bf3 = [
  {
    id: 1,
    type: "prompt",
    content:
      "Absolutely! To ensure the best fit, let's double-check the cup size. We can do this by having you try on the bra and checking for spillage. \n",
    options: [{ label: "Let’s check the cups", next: 2 }],
    next: 2,
  }, // braSizeInput
  {
    id: 2,
    type: "braSizeInput",
    content: "Enter your current bra size:",
    options: [{ label: "Bra Fit Quiz", next: 2 }],
    next: 3,
  },
  {
    id: 3,
    type: "promptWithImages",
    content:
      "Thanks for that, now, let’s put your bra on. Which image below resonates with your current fit the most?",
    options: [
      {
        label: "Significant spilling",
        image: cupOption1,
        next: 5,
      },
      {
        label: "Moderate Spilling",
        image: cupOption2,
        next: 6,
      },
      {
        label: "No spilling",
        image: cupOption3,
        next: 7,
      },
    ],
    next: 8,
  },

  {
    id: 5,
    type: "result",
    content:
      "I suggest you go up in 2 cup sizes. Making sure that you adjust the breasts in the cup properly when you try out the new size will help improving the fit too. ",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 6,
    type: "result",
    content: "I suggest you go up in 1 cup size. Making sure that you adjust the breasts in the cup properly when you try out the new size will help improving the fit too.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 7,
    type: "result",
    content:
      "I suggest you stay with the same cup size. If you wish to have more coverage, especially for when the breasts fluctuate in volumes such as when you’re out of the the menstrual cycle. we could look for bras with stretchy lace.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
];
